import PresentationVideoSwiper from "./PresentationVideoSwiperComponent";

export default PresentationVideoSwiper;